import React from 'react'
import { Spinner } from "reactstrap"

export const ImgTag = ({url,alt='img',className,title='',onClick}) => {
  return (
    <>
        <img src={url} alt={alt} title={title} className={className} onClick={onClick}/>
    </>
  )
}


export const ButtonComp = ({className,name,onClick}) => {
  
  return (
    <>
        <button className={className} onClick={()=>onClick()}>{name}</button>
    </>
  )
}

export const RequiredTag = () => <span className="text-danger">*</span>


export const MySpinner = () => {
  return (
    <div className='TracksLoader'>
    <Spinner color='primary' />
  </div>
  )
}